import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FlussoService } from "../../../@core/api/flusso.service";
import { CampaignProjectService } from "../../../@core/api/campaign-project.service";
import { Flusso } from "../../../@core/data/flusso";
import { Campaign } from "../../../@core/data/campaign";
import { FlussoFieldComponent } from "../flusso-field/flusso-field.component";
import { Router } from "@angular/router";

@Component({
  selector: "ngx-flusso-new",
  templateUrl: "./flusso-new.component.html",
  styleUrls: ["./flusso-new.component.scss"],
})
export class FlussoNewComponent implements OnInit {
  id: string;
  loading: boolean = false;
  editing: boolean = false;
  flusso: Flusso = {
    name: "",
    uid: "",
    id: "",
    settings: {},
    fields: [],
    privacies: [],
  };
  campaigns: Campaign[] = [];
  blocking = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private flussoService: FlussoService,
    private campaignService: CampaignProjectService
  ) {}

  async ngOnInit() {
    let id = this.route.snapshot.params["id"];

    if (id) {
      this.loading = true;
      this.editing = true;
      this.id = id;
      this.flusso = <Flusso>await this.flussoService.getFlusso(id);
    }

    this.campaigns = <any>(
      await this.campaignService.getCampaigns(
        { pageNumber: 0, perPage: 1000 },
        {},
        {}
      )
    );

    this.loading = false;

    if (!this.flusso.notAllowed) {
      this.flusso.notAllowed = {};
    }

    Object.keys(this.flusso.notAllowed).map((k) => {
      this.blocking.push({
        id: k,
        values: this.flusso.notAllowed[k].values,
        title: this.flusso.notAllowed[k].title,
      });
    });
  }

  addField() {
    this.flusso.fields.push({});
  }

  removeField(i) {
    this.flusso.fields.splice(i, 1);
  }

  addFieldPrivacy() {
    this.flusso.privacies.push({
      inputType: "check",
      validation: {
        exists: true,
      },
    });
  }

  removeFieldPrivacy(i) {
    this.flusso.privacies.splice(i, 1);
  }

  addBlockField(i) {
    this.blocking.push({
      id: "",
      values: "",
      title: "",
    });
  }

  removeBlockField(i) {
    this.blocking.splice(i, 1);
  }

  async updateField(data, index) {
    this.flusso.fields[index] = data;
  }

  async updateFieldPrivacy(data, index) {
    this.flusso.privacies[index] = data;
  }

  move(direction, index) {
    switch (direction) {
      case "down":
        if (index < this.flusso.fields.length - 1) {
          let moving = this.flusso.fields[index];
          this.flusso.fields[index] = this.flusso.fields[index + 1];
          this.flusso.fields[index + 1] = moving;
        }
        break;
      case "up":
        if (index > 0) {
          let moving = this.flusso.fields[index];
          this.flusso.fields[index] = this.flusso.fields[index - 1];
          this.flusso.fields[index - 1] = moving;
        }
        break;

      default:
        break;
    }
  }

  async save() {
    this.flusso.notAllowed = this.blocking;
    if (this.id) {
      console.log(this.flusso);

      try {
        await this.flussoService.editFlusso(this.flusso, this.id);
        this.router.navigate(["home", "flussi"]);
      } catch (e) {
        console.error(e);
      }
    } else {
      try {
        let data = <any>await this.flussoService.createFlusso(this.flusso);
        this.id = data.id;
        this.router.navigate(["home", "flussi"]);
      } catch (e) {
        console.error(e);
      }
    }
  }
}
